/**
 * PT-BR é a fonte da verdade. Chave desde a primeira string, porque
 * retro-encaixar i18n em 200 telas é o trabalho que ninguém faz.
 *
 * Voz da casa: sem travessão, plain no que é user-facing, termo técnico só
 * quando é o termo que o DP usa de verdade (apuração, rubrica, competência).
 */
export const PT_BR: Record<string, string> = {
  "app.nome": "EnturOS Pessoas",
  "app.buscar": "Buscar pessoa, matrícula ou CPF",
  "app.avisos": "Avisos",
  "app.conta": "Sua conta",

  "menu.painel": "Painel",
  "menu.grupo.pessoas": "Pessoas",
  "menu.pessoas": "Quadro de pessoas",
  "menu.admissao": "Admissão",
  "menu.afastamentos": "Afastamentos",
  "menu.grupo.jornada": "Jornada",
  "menu.ponto": "Ponto",
  "menu.espelho": "Espelho do mês",
  "menu.bancoDeHoras": "Banco de horas",

  "menu.grupo.atividade": "Atividade",
  "menu.combinado": "Combinado do dia",
  "menu.equipamentos": "Equipamentos",
  "menu.politicaMonitoramento": "Política de monitoramento",
  "menu.grupo.folha": "Folha",
  "menu.folha": "Fechamento",
  "menu.rubricas": "Rubricas",
  "menu.ferias": "Férias",
  "menu.rescisao": "Rescisão",
  "menu.grupo.obrigacoes": "Obrigações",
  "menu.esocial": "eSocial",
  "menu.arquivosFiscais": "AFD e AEJ",
  "menu.grupo.beneficios": "Benefícios",
  "menu.beneficios": "Elegibilidade",
  "menu.faturas": "Faturas",
  "menu.grupo.sst": "Saúde e segurança",
  "menu.exames": "Exames",
  "menu.epi": "EPI",
  "menu.acidentes": "Acidentes",
  "menu.psicossocial": "Riscos psicossociais",
  "menu.grupo.desenvolvimento": "Desenvolvimento",
  "menu.desempenho": "Desempenho",
  "menu.clima": "Clima",
  "menu.treinamento": "Treinamentos",
  "menu.grupo.gestao": "Gestão",
  "menu.relatorios": "Relatórios",
  "menu.configuracoes": "Configurações",
  "menu.equipe": "Quem tem acesso",

  "conta.perfil": "Meus dados",
  "conta.senha": "Trocar a senha",
  "conta.ajuda": "Ajuda e suporte",
  "conta.sair": "Sair do sistema",
  "conta.saindo": "Saindo",
  "conta.empresas": "Trocar de empresa",
  "conta.semEmpresa": "sem empresa",
  "conta.semPapel": "sem papel",

  "tema.claro": "Tema claro",
  "tema.escuro": "Tema escuro",
  "shell.recolher": "Recolher menu",
  "shell.expandir": "Expandir menu",
  "shell.redimensionar": "Ajustar a largura do menu",

  "estado.carregando": "Carregando",
  "estado.semRegistro": "sem registro",
  "estado.erroTitulo": "Não consegui carregar",
  "estado.erroAjuda": "Tente de novo. Se continuar, avise o suporte com o horário.",
};

export function t(chave: string): string {
  // Chave sem tradução aparece como a própria chave, de propósito: sumir em
  // silêncio esconde a falta, e o texto errado vai para o cliente.
  return PT_BR[chave] ?? chave;
}
